var map = {
	"./BLM/Firestarter.png": 2364,
	"./BLM/Ley Lines.png": 6498,
	"./BLM/Manaward.png": 2078,
	"./BLM/Sharpcast.png": 3772,
	"./BLM/ThunderDoT.png": 3074,
	"./BLM/Thunderhead.png": 8209,
	"./BLM/Triplecast.png": 4840,
	"./BLM/Triplecast2.png": 3480,
	"./BLM/Triplecast3.png": 4609,
	"./CasterRole/Addle.png": 1878,
	"./CasterRole/Lucid Dreaming.png": 2338,
	"./CasterRole/Surecast.png": 446,
	"./CasterRole/Swiftcast.png": 4694,
	"./CasterRole/Tincture.png": 4266,
	"./General/Sprint.png": 0,
	"./PCT/Aetherhues.png": 6321,
	"./PCT/Aetherhues2.png": 9207,
	"./PCT/Hammer Time.png": 4678,
	"./PCT/Hammer Time2.png": 7574,
	"./PCT/Hammer Time3.png": 1375,
	"./PCT/Hyperphantasia.png": 8375,
	"./PCT/Hyperphantasia2.png": 5084,
	"./PCT/Hyperphantasia3.png": 4501,
	"./PCT/Hyperphantasia4.png": 9834,
	"./PCT/Hyperphantasia5.png": 8691,
	"./PCT/Inspiration.png": 4035,
	"./PCT/Monochrome Tones.png": 4563,
	"./PCT/Rainbow Bright.png": 7397,
	"./PCT/Smudge.png": 4980,
	"./PCT/Starry Muse.png": 4316,
	"./PCT/Starstruck.png": 5691,
	"./PCT/Subtractive Palette.png": 3436,
	"./PCT/Subtractive Palette2.png": 9060,
	"./PCT/Subtractive Palette3.png": 189,
	"./PCT/Subtractive Spectrum.png": 4956,
	"./PCT/Tempera Coat.png": 802,
	"./PCT/Tempera Grassa.png": 5956
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2399;